// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"34eee54f","732":"0bd2c81a"}[chunkId] + ".chunk.js";
};